import { axiosInstance as axios } from "@/utils/wd_axios.js";
import { wdConfigData, userKeys, appIds } from "./wd_app_config.js";

// GlobalServices/Lookup?accountName=%@
export const wd_lookup = (params) => {
  var url = `${wdConfigData.baseURLGds}/GlobalServices/Lookup?accountName=${params.accountName}`;
  return axios.get(url, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

// Accounts/SignIn
// Post
// accountName, password, accountType,
export const wd_globalSignIn = (params) => {
  const Base64 = require("js-base64").Base64;
  var requestBody = {
    AccountName: params.accountName,
    Password: Base64.encode(params.password),
    AccountType: params.accountType,
  };
  var url = `${wdConfigData.baseURLGds}/Accounts/SignIn`;
  return axios.post(url, requestBody, {});
};

// Users/Info
// Get
// Global Service
export const wd_globalGetUser = () => {
  var url = `${wdConfigData.baseURLGds}/Users/Info`;
  return axios.get(url);
};

// Corporations/User/JoinStatus
// Get
// Global Service
export const wd_globalGetUserJoinStatus = (params) => {
  var url = `${wdConfigData.baseURLGds}/Corporations/User/JoinStatus`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${params.globalAccessToken}`,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

// CorporationServices/Lookup?accountName=%@&accountType=%u
// Get：normal account type
// Global service
export const wd_corporationLookup = (params) => {
  var url = `${wdConfigData.baseURLGds}/CorporationServices/Lookup?accountName=${params.accountName}&accountType=${params.accountType}`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${params.globalAccessToken}`,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

// /Corporations/%@/Apps/%@/Install
// Post
// dir service
export const wd_install = (params) => {
  var requestBody = {
    Platform: wdConfigData.platform,
    DeviceNativeId: params.deviceNativeId,
    AppClientId: appIds.appId_AppClientId,
    ClientVersion: "1.0",
  };
  var corporationId = localStorage.getItem(userKeys.key_corporationId);
  var url = `${wdConfigData.baseURLDir}/Corporations/${corporationId}/Apps/${appIds.appId_Dir}/Install`;
  return axios.post(url, requestBody, {});
};

// /Corporations/%@/SignIn
// Post
// dir service
export const wd_corporationSignIn = () => {
  var requestBody = {
    // ClientInstallationId: params.clientInstallationId,
    AccountType: localStorage.getItem(userKeys.key_accountType),
  };
  var corporationId = localStorage.getItem(userKeys.key_corporationId);
  var globalAccessToken = localStorage.getItem(userKeys.key_globalAccessToken);
  var url = `${wdConfigData.baseURLDir}/Corporations/${corporationId}/SignIn`;
  return axios.post(url, requestBody, {
    headers: {
      Authorization: `Bearer ${globalAccessToken}`,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

// /Apps/%@/Users/%@/Notifications
// Get
// dir service
export const wd_getNotifications = () => {
  var user = JSON.parse(localStorage.getItem(userKeys.key_userObject));
  var url = `${wdConfigData.baseUrlAn}/Apps/${appIds.appId_App}/Users/${user.Id}/Notifications`;
  return axios.get(url, {});
};

// Accounts/AccessToken/Refresh
// Post
// dir service
export const wd_refreshGlobalAccessToken = () => {
  var globalRefreshToken = localStorage.getItem(
    userKeys.key_globalRefreshToken
  );
  var url = `${wdConfigData.baseURLGds}/Accounts/AccessToken/Refresh`;
  return axios.post(url, { GlobalRefreshToken: globalRefreshToken });
};

// SignUp：/VerificationCode/Send
// Post
// dir service
export const api_sendVerificationCode = (params) => {
  var requestBody = {
    Usage: params.Usage,
    AccountName: params.AccountName,
    AccountType: params.AccountType,
    RefreshVerificationCode: params.RefreshVerificationCode,
    CaptchaKey: params.CaptchaKey,
    CaptchaCode: params.CaptchaCode,
    LcId: params.LcId
  };
  var url = `${wdConfigData.baseURLGds}/VerificationCode/Send`;
  return axios.post(url, requestBody, {});
};

// SignUp：/Accounts/SignUp
// Post
// dir service
export const api_AccountsSignUp = (params) => {
  const Base64 = require("js-base64").Base64;
  var requestBody = {
    AccountName: params.accountName,
    AccountType: params.loginType,
    UserName:params.userName,
    VerificationCode: params.vcode,
    UserPortraitUrl:"",
    Password:Base64.encode(params.password),
    RegionId: params.regionId
  };
  var url = `${wdConfigData.baseURLGds}/Accounts/SignUp`;
  return axios.post(url, requestBody, {});
};


// SignUp：/SignUpApi/OC/Corporations/{0}/Join
// Post
// dir service
export const api_AccountsJoinCorporation = (params) => {
  var url = `${wdConfigData.baseURLGbo}/SignUpApi/OC/Corporations/${params.corporationId}/Join`;
  return axios.post(url, {}, {
    headers: {
      Authorization: `Bearer ${params.globalAccessToken}`,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};


// 获取验证码
export const wd_getcode = (params) => {
  // const Base64 = require("js-base64").Base64;
  var requestBody = {
    AccountName: params.accountName,
    Usage: "128",
    AccountType: 2048,
    RefreshVerificationCode:"true"
  };
  var url = `${wdConfigData.baseURLGds}/VerificationCode/Send`;
  return axios.post(url, requestBody, {});
};

// 申请账号
export const wd_getaccount = (params) => {
  // const Base64 = require("js-base64").Base64;
  var requestBody = {
    AccountName: params.accountName,
    AccountType: 10,
    Name: params.name,
    VerificationCode:params.code
  };
  var url = `${wdConfigData.baseURLGds}/Corporations/${params.CorporationId}/GPTScanQRCode/SignUp`;
  return axios.post(url, requestBody, {});
};
